var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.84558 4.03412V0.658109C7.84558 0.299141 8.13459 0 8.50009 0C8.82734 0 9.10459 0.251361 9.14852 0.569752L9.15458 0.658109V4.03412L13.2175 4.03438C15.2405 4.03438 16.9025 5.67561 16.9959 7.72245L17 7.90408V12.1477C17 14.2089 15.3958 15.9008 13.4028 15.9958L13.226 16H3.774C1.751 16 0.0969763 14.367 0.00411212 12.3126L0 12.1303V7.89538C0 5.83419 1.59622 4.13407 3.5887 4.03861L3.7655 4.03438H7.8455V9.42587L6.4855 8.03451C6.2305 7.77364 5.814 7.77364 5.559 8.03451C5.4315 8.16495 5.372 8.33887 5.372 8.51279C5.372 8.64497 5.41008 8.78271 5.49059 8.89931L5.559 8.98237L8.0325 11.5216C8.1515 11.652 8.3215 11.7216 8.5 11.7216C8.64167 11.7216 8.78333 11.6733 8.89549 11.5817L8.959 11.5216L11.4325 8.98237C11.6875 8.72149 11.6875 8.29539 11.4325 8.03451C11.2007 7.79735 10.8354 7.77579 10.5793 7.96983L10.506 8.03451L9.1545 9.42587V4.03438L7.84558 4.03412Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.19b5c1a81e5424e9f0b317c6a619f10f.svg";
export { ForwardRef as ReactComponent };